export const metaTitlesForCountryDict = {
  en: {
    title: `{countryName} Properties for Sale: Real Estate & Homes Listing — {project}`,
    description: `{project} offers a list of investment real estate for sale in {countryName}. Choose an apartment, a house, or a share in commercial property to get a second citizenship or a "golden visa"`,
  },

  ru: {
    title: `Недвижимость в {countryName}: купить жилье, цены на дома – {project}`,
    description: `Покупка недвижимости в {countryName} для участия в инвестиционной программе. Только проверенные объекты от лицензированного представителя программы – {project}`,
  },
};

export const metaTitlesForManagerPageDict = {
  en: {
    title: `Page for managers - {project}`,
    description: '',
  },

  ru: {
    title: `Страница для менеджеров - {project}`,
    description: '',
  },
};

export const metaTitlesForPropertyTypeDict = {
  en: {
    default: {
      title: `{typeTitle} for Sale — Investment Properties from {project}`,
      description: `Best {typeDescription} for investment ✔️ Choose investment real estate to get a second citizenship or a "golden visa"`,
    },
    withCountry: {
      title: `{typeTitle} for Sale in {countryName} — Investment Properties from {project}`,
      description: `Best {typeDescription} for investment in {countryName} ✔️ Choose investment real estate to get a second citizenship or a "golden visa"`,
    },
  },
  ru: {
    default: {
      title: `{typeTitle}: купить жилье, цены на дома – {project}`,
      description: `Покупка {typeDescription} для участия в инвестиционной программе. Только проверенные объекты от лицензированного представителя программы – {project}`,
    },
    withCountry: {
      title: `{typeTitle} в {countryName}: купить жилье, цены на дома – {project}`,
      description: `Покупка {typeDescription} в {countryName} для участия в инвестиционной программе. Только проверенные объекты от лицензированного представителя программы – {project}`,
    },
  },
};

export const metaTitlesForObjectStageDict = {
  en: {
    'under-construction': {
      title:
        'Buying property under construction abroad - overseas property from Immigrant Invest',
      description:
        'Buying real estate under construction abroad for an investment programme. Only verified properties from a licensed investment programme representative - Immigrant Invest',
    },
  },
  de: {
    'under-construction': {
      title:
        'Im Bau befindliche Immobilien im Ausland kaufen – Auslandsimmobilien von Immigrant Invest',
      description:
        'Kauf von im Bau befindlichen Immobilien im Ausland für ein Investitionsprogramm. Nur geprüfte Immobilien von einem lizenzierten Vertreter des Investitionsprogramms – Immigrant Invest',
    },
  },
  ru: {
    'under-construction': {
      title:
        'Купить недвижимость за границей на этапе строительства – зарубежная недвижимость от Иммигрант Инвест',
      description:
        'Купить недвижимость за границей на этапе строительства – зарубежная недвижимость от Иммигрант Инвест',
    },
  },
  tr: {
    'under-construction': {
      title:
        'Yurt dışında inşaat aşamasındaki gayrimenkul alımı – Immigrant Invest yurt dışı gayrimenkulleri',
      description:
        'Yurt dışında inşaat aşamasındaki gayrimenkul alımı yatırım programı için. Sadece lisanslı yatırım programı temsilcisinden doğrulanmış gayrimenkuller – Immigrant Invest',
    },
  },
};

export const metaProjectTitleDict = {
  en: {
    imin: 'Immigrant Invest',
    psy: 'Passportivity',
  },
  de: {
    imin: 'Immigrant Invest',
    psy: 'Passportivity',
  },
  ru: {
    imin: 'Иммигрант Инвест',
    psy: 'Паспортивити',
  },
  tr: {
    imin: 'Immigrant Invest',
    psy: 'Passportivity',
  },
};

export const estateMainMetaDict = {
  en: {
    title:
      'Real Estate for Sale to Get Citizenship & Residence Permit: Investing in Property Abroad',
    description:
      'Purchase real estate in the EU, the Middle East, and Caribbean countries to obtain citizenship or residency. Only verified properties suitable for investment programs from {project}',
  },
  de: {
    title:
      'Immobilien für Staatsbürgerschaft und Aufenthaltserlaubnis: Kauf, Investition in Immobilien im Ausland',
    description:
      'Kauf von Immobilien in Europa oder der Karibik zur Erlangung der Staatsbürgerschaft, Aufenthaltserlaubnis oder des dauerhaften Aufenthaltsstatus. Nur geprüfte Immobilien, die für Investitionsprogramme geeignet sind - from {project}',
  },
  ru: {
    title:
      'Гражданство и ВНЖ при покупке недвижимости: инвестиции в недвижимость за рубежом',
    description:
      'Покупка недвижимости в Европе или странах Карибского бассейна для получения гражданства, ВНЖ, ПМЖ. Только проверенные объекты, подходящие для участия в инвестиционных программах – {project}',
  },
  tr: {
    title:
      'Satılık Emlak ile Vatandaşlık ve İkamet İzni Alımı: Yurt Dışında Gayrimenkul Yatırımı',
    description:
      'Avrupa, Orta Doğu ve Karayip ülkelerinde gayrimenkul satın alarak vatandaşlık veya oturma izni alın. Yalnızca {project} yatırım programlarına uygun, doğrulanmış gayrimenkuller',
  },
};

export const estateSearchMetaDict = {
  en: {
    title: 'Worldwide real estate search assistance - {project}',
    description:
      'Real estate search in Europe and the Caribbean. Only verified properties suitable for investment programmes - {project}',
  },
  de: {
    title: 'Weltweite Unterstützung bei der Immobiliensuche - {project}',
    description:
      'Immobiliensuche in Europa und der Karibik. Nur geprüfte Immobilien, die für Investitionsprogramme geeignet sind - {project}',
  },
  ru: {
    title: 'Поиск недвижимости за рубежом – {project}',
    description:
      'Поиск недвижимости в Европе и странах Карибского бассейна. Только проверенные объекты, подходящие для участия в инвестиционных программах – {project}',
  },
  tr: {
    title: 'Dünya Çapında Emlak Arama Yardımı – {project}',
    description:
      'Avrupa ve Karayipler’deki gayrimenkul aramaları. Yalnızca {project} yatırım programlarına uygun doğrulanmış gayrimenkuller',
  },
};
